import { useEffect, type ReactNode, useState } from "react";
import MinimizeIcon from "@mui/icons-material/Minimize";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import ChartTitle from "./ChartTitle";
import { chartCardShellClass, chartCardShellStyle } from "./chartCardStyle";

type ChartContainerProps = {
  children: ReactNode;
  isMessage?: boolean;
  alignTop?: boolean;
  className?: string;
  minimizeID?: string;
  /** Grow with children instead of filling parent; avoids clipping tall charts + legends in flex/grid. */
  fitContent?: boolean;
};

function ChartContainer({
  children,
  isMessage = false,
  alignTop = false,
  className,
  minimizeID = undefined,
  fitContent = false,
}: ChartContainerProps) {
  const [isMinimized, setIsMinimized] = useState(false);
  useEffect(() => {
    if (minimizeID) {
      setIsMinimized(localStorage.getItem(minimizeID) === "true");
    }
  }, [minimizeID]);

  const supportMinimize = false;
  return (
    <div
      className={`${chartCardShellClass} ${className ? className : ""} ${
        isMessage
          ? "margin-auto ml-2 mr-2 flex w-[620px] justify-center self-center mobile:w-full md:min-h-[471px]"
          : `flex flex-col flex-wrap items-center font-medium text-menu ${
              fitContent ? "h-auto" : "h-full min-h-0"
            } ${alignTop ? "justify-start" : "justify-around"}`
      }`}
      style={chartCardShellStyle}
    >
      {supportMinimize &&
        (isMinimized ? (
          <div className={`right-0 top-0 flex flex-wrap`}>
            <OpenInFullIcon
              className="me-2 ms-10 self-center"
              onClick={() => {
                setIsMinimized(false);
                if (minimizeID) {
                  localStorage.setItem(minimizeID, false.toString());
                }
              }}
            />
            <ChartTitle text={minimizeID ? minimizeID : ""} />
          </div>
        ) : (
          <div className="relative z-10 h-0 w-0 lg:hidden">
            <MinimizeIcon
              onClick={() => {
                setIsMinimized(true);
                if (minimizeID) {
                  localStorage.setItem(minimizeID, true.toString());
                }
              }}
              className="absolute right-1 top-0 z-10"
            />
          </div>
        ))}
      <div
        className={`transition-scale w-full duration-500 ease-in-out ${
          isMinimized
            ? "max-h-0 scale-0 overflow-y-hidden"
            : fitContent
            ? "shrink-0"
            : "min-h-0 flex-1 overflow-hidden"
        }`}
        style={{ minHeight: isMinimized ? undefined : 0 }}
      >
        {children}
      </div>
    </div>
  );
}
export default ChartContainer;
